<template>
    <h4 class="mb-4">{{ translate("Social media accounts") }}</h4>

    <div class="form-group fv-plugins-icon-container">
        <label>Facebook</label>
        <input
            type="text"
            class="form-control form-control-solid form-control-lg"
            id="dm-manuscript-facebook"
            :placeholder="translate('Facebook')"
            v-model="author_social_links.facebook"
            @change="saveAuthorSocialLinks()"
        />
    </div>

    <div class="form-group fv-plugins-icon-container">
        <label>TikTok</label>
        <input
            type="text"
            class="form-control form-control-solid form-control-lg"
            id="dm-manuscript-tiktok"
            :placeholder="translate('TikTok')"
            v-model="author_social_links.tiktok"
            @change="saveAuthorSocialLinks()"
        />
    </div>

    <div class="form-group fv-plugins-icon-container">
        <label>Instagram</label>
        <input
            type="text"
            class="form-control form-control-solid form-control-lg"
            id="dm-manuscript-instagram"
            :placeholder="translate('Instagram')"
            v-model="author_social_links.instagram"
            @change="saveAuthorSocialLinks()"
        />
    </div>

    <div class="form-group fv-plugins-icon-container">
        <label>X</label>
        <input
            type="text"
            class="form-control form-control-solid form-control-lg"
            id="dm-manuscript-twitter"
            :placeholder="translate('X')"
            v-model="author_social_links.twitter"
            @change="saveAuthorSocialLinks()"
        />
    </div>

    <div class="form-group fv-plugins-icon-container">
        <label>{{ translate("Website") }}</label>
        <input
            type="text"
            class="form-control form-control-solid form-control-lg"
            id="dm-manuscript-website"
            :placeholder="translate('Website')"
            v-model="author_social_links.website"
            @change="saveAuthorSocialLinks()"
        />
    </div>
</template>

<script>
import { useSubmissionWizardStore } from "@storesSw/SubmissionWizardStore";
import { mapWritableState, mapActions } from "pinia";
export default {
    computed: {
        ...mapWritableState(useSubmissionWizardStore, [
            "author_social_links",
            "bottom_navigation_rules",
        ]),
    },

    methods: {
        ...mapActions(useSubmissionWizardStore, ["saveAuthorSocialLinks"]),
    },
};
</script>
